<script lang="ts">
    import { get } from 'svelte/store';
    import { onMount } from 'svelte';
    import { _ } from 'svelte-i18n';

    import { currentImport } from '../../shared/ColumnSelectPro/currentImport.js';
    import ProgressBar from '../../shared/ProgressBar.svelte';
    import { api } from '../../../stores/api';
    import { ImportApi } from './ImportApi';

    export let progressPercent: number = 0;
    export let error: string = '';
    export let autoHideWhenInactive: boolean = false;

    let intervalHandler: any = null;

    function checkImportStatus() {
        if ($currentImport !== null) {
            ImportApi.getStatus(get(api), $currentImport.id)
                .then(response => {
                    progressPercent = response.percent;
                    if (response.percent >= 100) {
                        // if ($currentImport !== null) {
                        //     ImportApi.updateJobs(get(api), $currentImport.id).then(res => {
                        //         console.log('update jobs', res);
                        //     });
                        // }
                        if (intervalHandler) clearInterval(intervalHandler);
                    } else {
                        intervalHandler = setTimeout(() => {
                            checkImportStatus();
                        }, 3000);
                    }
                })
                .catch(err => {
                    if (intervalHandler) clearInterval(intervalHandler);
                    console.log(err);
                    error = err;
                });
        } else {
            console.info('No import to check');
        }
    }

    onMount(() => {
        intervalHandler = setTimeout(() => {
            checkImportStatus();
        }, 3000);

        return () => {
            if (intervalHandler) clearInterval(intervalHandler);
        };
    });

    // $: {
    //     isAnythingToLoad = $currentImport!==null;
    //     if (isAnythingToLoad && intervalHandler === null) {
    //         intervalHandler = setInterval( () => {
    //             checkImportStatus();
    //         }, 1000);
    //     }
    //
    // }
</script>

{#if autoHideWhenInactive && ($currentImport === null || progressPercent >= 100 || progressPercent <= 0)}
    <div class="hidden"></div>
{:else}
    <ProgressBar current={progressPercent} withShadow={false} label={$_('Geocoding')} />
{/if}
